import React from "react";
import { useHistory } from "react-router-dom";
import JobManager from "../components/JobManager";
import { useTranslation } from "../hooks/useTranslation";
import FileDownload from "../components/FileDownload";
import { Box, Typography } from "@material-ui/core";

const ProcessamentosPage = () => {
  const history = useHistory();
  const { t } = useTranslation('jobs');

  // Configuração das colunas da tabela
  const columns = [
    {
      key: "insertion_timestamp",
      label: t('table.dateTime'),
      type: "date",
      sortable: true,
    },
    {
      key: "status",
      label: t('table.status'),
      type: "status",
      sortable: true,
      formatValue: (value) => {
        return t(`status.${value}`) || value;
      },
    },
    {
      key: "user_name",
      label: t('table.user'),
      type: "user",
      sortable: true,
    },
    {
      key: "input_document",
      label: t('table.inputDocument'),
      type: "custom",
      sortable: false,
      renderCell: (job) => {
        // Acessar o documento do input_params
        const document = job?.input_params?.document;
        
        if (!document || !document.filename) {
          return (
            <Typography variant="body2" style={{ color: "var(--ikaro-gray-dark)", fontSize: '0.75rem' }}>
              -
            </Typography>
          );
        }
        
        return (
          <Box>
            <FileDownload 
              file={document}
              showError={false}
            />
          </Box>
        );
      },
    },
    {
      key: "input_payload",
      label: t('table.inputs'),
      type: "files",
      sortable: false,
    },
    {
      key: "output_payload",
      label: t('table.outputs'),
      type: "outputs",
      sortable: false,
    },
    // {
    //   key: "cell_name",
    //   label: t('table.cell'),
    //   type: "cell",
    //   sortable: true,
    // },
    // {
    //   key: "actions",
    //   label: t('table.actions'),
    //   type: "actions",
    //   sortable: false,
    // },
  ];

  // Configuração dos campos de filtro
  const filterFields = [
    // Filtros obrigatórios para todos os tipos de trabalho
    {
      key: "job_id",
      label: t('filters.jobId'),
      type: "text",
      placeholder: t('filters.jobIdPlaceholder'),
    },
    {
      key: "external_id",
      label: t('filters.externalId'),
      type: "text",
      placeholder: t('filters.externalIdPlaceholder'),
    },
    {
      key: "date_start",
      label: t('filters.dateStart'),
      type: "date",
    },
    {
      key: "date_end",
      label: t('filters.dateEnd'),
      type: "date",
    },
    // Filtros específicos para processamentos
    {
      key: "user_name_filter",
      label: t('filters.user'),
      type: "text",
      placeholder: t('filters.userPlaceholder'),
    },
    {
      key: "status_filter",
      label: t('filters.status'),
      type: "select",
      options: [
        { value: "DONE", label: t('status.DONE') },
        { value: "WAITING", label: t('status.WAITING') },
        { value: "RUNNING", label: t('status.RUNNING') },
        { value: "ERROR", label: t('status.ERROR') },
        { value: "FINAL_ERROR", label: t('status.FINAL_ERROR') },
      ],
    },
    {
      key: "output_payload_text_filter",
      label: t('filters.outputContent'),
      type: "text",
      placeholder: t('filters.outputContentPlaceholder'),
    },
  ];

  // Ações customizadas para a tabela
  const customActions = [
    {
      key: "reprocess",
      icon: "🔄",
      tooltip: t('actions.reprocessTooltip'),
      disabled: (job) => job.status !== "ERROR",
    },
  ];

  // Handlers para ações
  const handleNewJob = () => {
    history.push("/processamento/novo");
  };

  const handleJobClick = (job) => {
    console.log("Tarefa clicada:", job);
    // Navegar para detalhes ou abrir modal
  };

  const handleJobAction = (action, job) => {
    console.log("Ação executada:", action, "na tarefa:", job);

    switch (action) {
      case "view":
        // Abrir modal de detalhes ou navegar para página de detalhes
        console.log("Visualizar tarefa:", job.id);
        break;

      case "download":
        // Fazer download dos resultados
        console.log("Download resultados:", job.id);
        downloadJobResults(job);
        break;

      case "reprocess":
        // Reprocessar tarefa
        console.log("Reprocessar tarefa:", job.id);
        reprocessJob(job);
        break;

      default:
        console.log("Ação desconhecida:", action);
    }
  };

  const downloadJobResults = (job) => {
    // Implementar download dos resultados
    if (job.output_payload) {
      try {
        const blob = new Blob([JSON.stringify(job.output_payload, null, 2)], {
          type: "application/json",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `job_${job.id}_results.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao fazer download:", error);
      }
    }
  };

  const reprocessJob = (job) => {
    // Implementar reprocessamento
    console.log("Reprocessando tarefa:", job.id);
    // Aqui você faria uma chamada para a API para reprocessar a tarefa
  };

  return (
    <JobManager
      jobType="processamento"
      title={t('processings:title')}
      subtitle={t('processings:subtitle')}
      apiEndpoint="/job/get_jobs_list"
      createJobPath="/processamento/novo"
      columns={columns}
      filterFields={filterFields}
      customActions={customActions}
      onNewJob={handleNewJob}
      onJobClick={handleJobClick}
      onJobAction={handleJobAction}
      customFilters={{
        code: "PROCESS_DIGITAL_PDF", // Código específico para processamento de documentos PDF
      }}
    />
  );
};

export default ProcessamentosPage;
